export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-en@2x-fc87c56eb237392c80c08b37d898eb03.webp";